import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=395c6a3c"
import script from "./MainPage.vue?vue&type=script&lang=ts"
export * from "./MainPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports